import { makeResetMutation } from '@utils/reset-store'
import { coerceWalletAnalysisPayload } from '@modules/consolidator/utils/adapt-wallet-analysis-response/adapt-wallet-analysis-response'
import { buildDefaultWalletFiltersData } from '@modules/consolidator/utils/normalize-wallet-filters/normalize-wallet-filters'
import { coerceToArray } from '@utils/Format'
import { upsertListItem } from '@modules/consolidator/utils/upsert-list-item/upsert-list-item'
import { FILTER_MODE } from '@modules/consolidator/constants/filter-mode'
import {
  buildDefaultFamilyGroupFilters,
  buildInitialState,
  PREFERENCES_STORAGE_KEY,
  VIEW_MODES,
} from './state'

const VALID_VIEW_MODES = new Set([
  VIEW_MODES.ESTRATEGICA,
  VIEW_MODES.DESENQUADRAMENTO,
])

const _persistPreferences = (preferences) => {
  try {
    if (globalThis.window === undefined || !globalThis.window.localStorage) {
      return
    }
    globalThis.window.localStorage.setItem(
      PREFERENCES_STORAGE_KEY,
      JSON.stringify(preferences)
    )
  } catch (error) {
    // localStorage may be unavailable (private mode, quota exceeded); log and continue
    console.warn(
      '[consolidator] Falha ao persistir preferências no localStorage:',
      error
    )
  }
}

// Mutations
export const SET_PREFERENCE_VIEW_MODE = (state, payload) => {
  const next = VALID_VIEW_MODES.has(payload) ? payload : VIEW_MODES.ESTRATEGICA
  state.preferences = { ...state.preferences, viewMode: next }
  _persistPreferences(state.preferences)
}

export const SET_CONSOLIDATE_EXTRACTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.consolidateExtracts.data = payload
    state.consolidateExtracts.lastUpdate = new Date()
  }
}
export const SET_CONSOLIDATE_EXTRACTS_LOADING = (state, payload) => {
  state.consolidateExtracts.loading = payload
}

export const SET_COTIZACAO = (state, payload) => {
  if (payload && typeof payload === 'object') {
    if (payload.id_cliente) {
      state.cotizacao.data[payload.id_cliente] = payload.loading
    }
    // state.cotizacao.data = payload
    state.cotizacao.lastUpdate = new Date()
  }
}
export const SET_COTIZACAO_LOADING = (state, payload) => {
  state.cotizacao.loading = payload
}

export const SET_OVERVIEW = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.overview.data = payload
    state.overview.lastUpdate = new Date()
  }
}
export const SET_OVERVIEW_LOADING = (state, payload) => {
  state.overview.loading = payload
}

export const SET_OVERVIEW_FILTERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.overviewFilters.data = payload
    state.overviewFilters.lastUpdate = new Date()
  }
}
export const SET_OVERVIEW_FILTERS_LOADING = (state, payload) => {
  state.overviewFilters.loading = payload
}

export const SET_ASSETS_LIQUIDITY = (state, payload) => {
  const { data, clientId } = payload || {}
  if (data && typeof data === 'object') {
    state.assetsLiquidity.data = data
    state.assetsLiquidity.clientId = clientId == null ? null : clientId
    state.assetsLiquidity.lastUpdate = new Date()
  }
}
export const SET_ASSETS_LIQUIDITY_LOADING = (state, payload) => {
  state.assetsLiquidity.loading = payload
}

export const SET_CLIENT_ASSETS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.clientAssets.data = payload
    state.clientAssets.lastUpdate = new Date()
  }
}
export const SET_CLIENT_ASSETS_LOADING = (state, payload) => {
  state.clientAssets.loading = payload
}

export const SET_SEARCH_ASSETS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.searchAssets.data = payload
    state.searchAssets.lastUpdate = new Date()
  }
}
export const ADD_SEARCH_ASSETS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const dados = Array.isArray(payload) ? payload : [payload]
    dados.forEach((data) => {
      upsertListItem({
        list: state.searchAssets.data,
        item: data,
        matchKey: 'nome',
      })
    })
  }
}
export const SET_SEARCH_ASSETS_LOADING = (state, payload) => {
  state.searchAssets.loading = payload
}

export const SET_CLIENT_DATA_OUTDATED = (state, payload) => {
  state.clientsDataOutdated.data = payload
}

export const SET_RECOTIZACAO_EM_ANDAMENTO = (state, payload) => {
  state.recotizacaoEmAndamento.data = payload
}

export const ADD_RECENTLY_LINKED_ASSET = (state, payload) => {
  if (payload === null || payload === undefined) return
  if (!state.recentlyLinkedAssetIds.includes(payload)) {
    state.recentlyLinkedAssetIds.push(payload)
  }
}

export const SET_VERSION_CLOSING = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.versionClosing.data = payload
    state.versionClosing.lastUpdate = new Date()
  }
}
export const SET_VERSION_CLOSING_LOADING = (state, payload) => {
  state.versionClosing.loading = payload
}
export const SET_BACK_OFFICE_COMPARISON = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.backOfficeComparison.data = payload
    state.backOfficeComparison.lastUpdate = new Date()
  }
}
export const ADD_BACK_OFFICE_COMPARISON = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const dados = Array.isArray(payload) ? payload : [payload]
    dados.forEach((data) => {
      upsertListItem({
        list: state.backOfficeComparison.data,
        item: data,
        matchKey: 'id',
      })
    })
  }
}
export const SET_BACK_OFFICE_COMPARISON_LOADING = (state, payload) => {
  state.backOfficeComparison.loading = payload
}

export const SET_INVESTMENT_ACCOUNT = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.investmentAccount.data = payload
    state.investmentAccount.lastUpdate = new Date()
  }
}
export const SET_INVESTMENT_ACCOUNT_LOADING = (state, payload) => {
  state.investmentAccount.loading = payload
}

export const SET_FULL_WALLET = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.fullWallet.data = payload
    state.fullWallet.lastUpdate = new Date()
  }
}
export const SET_FULL_WALLET_BROKERS = (state, payload) => {
  state.fullWallet.brokers = payload
}

export const SET_FULL_WALLET_PORTFOLIO = (state, payload) => {
  state.fullWallet.portfolios = payload
}
export const SET_CORRELATIONS = (state, payload) => {
  const { data, clientId } = payload || {}
  if (data && typeof data === 'object') {
    state.correlations.data = data
    state.correlations.clientId = clientId == null ? null : clientId
    state.correlations.lastUpdate = new Date()
  }
}
export const SET_CORRELATIONS_LOADING = (state, payload) => {
  state.correlations.loading = payload
}

export const SET_RISK_METRICS = (state, payload) => {
  const { data, clientId } = payload || {}
  if (data && typeof data === 'object') {
    state.riskMetrics.data = data
    state.riskMetrics.clientId = clientId == null ? null : clientId
    state.riskMetrics.lastUpdate = new Date()
  }
}
export const SET_RISK_METRICS_LOADING = (state, payload) => {
  state.riskMetrics.loading = payload
}

export const SET_INSIGHTS_IA = (state, payload) => {
  const { data, clientId } = payload || {}
  if (data && typeof data === 'object') {
    state.InsightsIa.data = data
    state.InsightsIa.clientId = clientId == null ? null : clientId
    state.InsightsIa.lastUpdate = new Date()
  }
}
export const SET_INSIGHTS_IA_LOADING = (state, payload) => {
  state.InsightsIa.loading = payload
}
export const SET_ANALISYS_ADVANCED = (state, payload) => {
  const { data, clientId } = payload || {}
  if (data && typeof data === 'object') {
    state.analisysAdvanced.data = data
    state.analisysAdvanced.clientId = clientId == null ? null : clientId
    state.analisysAdvanced.lastUpdate = new Date()
  }
}
export const SET_ANALISYS_ADVANCED_LOADING = (state, payload) => {
  state.analisysAdvanced.loading = payload
}

export const SET_CARTEIRA_ATIVOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.carteiraAtivos.data = payload
    state.carteiraAtivos.lastUpdate = new Date()
  }
}
export const SET_CARTEIRA_ATIVOS_LOADING = (state, payload) => {
  state.carteiraAtivos.loading = payload
}

export const SET_INVESTMENT_ACCOUNTS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.investmentAccounts.data = payload
    state.investmentAccounts.lastUpdate = new Date()
  }
}
export const SET_INVESTMENT_ACCOUNTS_LOADING = (state, payload) => {
  state.investmentAccounts.loading = payload
}

export const SET_SIMULATOR_RESULT = (state, payload) => {
  const { data, clientId } = payload || {}
  if (data && typeof data === 'object') {
    state.simulatorResult.data = data
    state.simulatorResult.clientId = clientId == null ? null : clientId
    state.simulatorResult.lastUpdate = new Date()
  }
}
export const SET_SIMULATOR_RESULT_LOADING = (state, payload) => {
  state.simulatorResult.loading = payload
}

export const SET_WALLET_FILTERS_MODO = (state, payload) => {
  state.walletFilters.data.modoFiltroCorretora = payload
}
export const SET_WALLET_FILTERS_CORRETORA = (state, payload) => {
  state.walletFilters.data.filtroCorretora = coerceToArray(payload)
}
export const SET_WALLET_FILTERS_DATA = (state, payload) => {
  state.walletFilters.data.filtroData = payload
}
export const SET_WALLET_FILTERS_INVESTMENT_TYPE = (state, payload) => {
  state.walletFilters.data.investmentTypeFilter = payload
}
export const SET_WALLET_FILTERS_LAST_VALID_DATA = (state, payload) => {
  state.walletFilters.data.lastValidFiltroData = payload
}
export const SET_WALLET_FILTERS_DATA_INICIO = (state, payload) => {
  state.walletFilters.data.dataInicio = payload
}
export const SET_WALLET_FILTERS_DATA_FIM = (state, payload) => {
  state.walletFilters.data.dataFim = payload
}
export const SET_WALLET_FILTERS_TIPO = (state, payload) => {
  state.walletFilters.data.tipo = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_SUBTIPO = (state, payload) => {
  state.walletFilters.data.subtipo = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_CLASSE = (state, payload) => {
  state.walletFilters.data.classe = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_SUBCLASSE = (state, payload) => {
  state.walletFilters.data.subclasse = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_SETOR = (state, payload) => {
  state.walletFilters.data.setor = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_EMISSOR = (state, payload) => {
  state.walletFilters.data.emissor = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_ID_CONTA = (state, payload) => {
  state.walletFilters.data.idConta = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_TAGS = (state, payload) => {
  state.walletFilters.data.tags = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_INSTITUICAO = (state, payload) => {
  state.walletFilters.data.instituicao = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_PORTFOLIO = (state, payload) => {
  state.walletFilters.data.portfolio = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_FILTERS_USER_CHANGED_FIELD = (state, payload) => {
  if (!payload || typeof payload !== 'object') return
  const { key, value } = payload
  if (!key) return
  state.walletFilters.data.userChangedFields = {
    ...state.walletFilters.data.userChangedFields,
    [key]: !!value,
  }
}
export const SET_WALLET_FILTERS_ALL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    Object.keys(payload).forEach((key) => {
      if (key in state.walletFilters.data) {
        state.walletFilters.data[key] = payload[key]
      }
    })
  }
}
export const RESET_WALLET_FILTERS = (state) => {
  Object.assign(state.walletFilters.data, buildDefaultWalletFiltersData())
}

export const SET_WALLET_ANALYSIS = (state, payload) => {
  state.walletAnalysis.data = coerceWalletAnalysisPayload(payload)
  state.walletAnalysis.lastUpdate = new Date()
}
export const SET_WALLET_ANALYSIS_LOADING = (state, payload) => {
  state.walletAnalysis.loading = payload
}

export const SET_WALLET_ANALYSIS_OPTIONS_FIELDS = (state, payload) => {
  state.walletAnalysisOptionsFields.data = Array.isArray(payload) ? payload : []
}
export const SET_WALLET_ANALYSIS_OPTIONS_FIELDS_LOADING = (state, payload) => {
  state.walletAnalysisOptionsFields.loading = !!payload
}

export const SET_STATISTICS_PER_ASSET = (state, payload) => {
  const { data, clientId } = payload || {}
  state.statisticsPerAsset.data = data && typeof data === 'object' ? data : {}
  state.statisticsPerAsset.clientId = clientId == null ? null : clientId
  state.statisticsPerAsset.lastUpdate = new Date()
}
export const SET_STATISTICS_PER_ASSET_LOADING = (state, payload) => {
  state.statisticsPerAsset.loading = !!payload
}

export const SET_ASSET_SERIES = (state, payload) => {
  state.assetSeries.data = payload && typeof payload === 'object' ? payload : {}
  state.assetSeries.lastUpdate = new Date()
}

export const SET_ASSET_SERIES_BENCHMARKS = (state, payload) => {
  state.assetSeriesBenchmarks.data =
    payload && typeof payload === 'object' ? payload : {}
  state.assetSeriesBenchmarks.lastUpdate = new Date()
}

export const SET_PORTFOLIOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.portfolios.data = payload
    state.portfolios.lastUpdate = new Date()
  }
}
export const SET_PORTFOLIOS_LOADING = (state, payload) => {
  state.portfolios.loading = payload
}

export const SET_PROVENTOS = (state, payload) => {
  const { data, clientId } = payload || {}
  state.proventos.data = data && typeof data === 'object' ? data : {}
  state.proventos.clientId = clientId == null ? null : clientId
  state.proventos.lastUpdate = new Date()
}
export const SET_PROVENTOS_LOADING = (state, payload) => {
  state.proventos.loading = payload
}

export const SET_SPLITS = (state, payload) => {
  const { data, clientId } = payload || {}
  state.splits.data = data && typeof data === 'object' ? data : {}
  state.splits.clientId = clientId == null ? null : clientId
  state.splits.lastUpdate = new Date()
}
export const SET_SPLITS_LOADING = (state, payload) => {
  state.splits.loading = payload
}

export const SET_CURRENT_FAMILY_GROUP = (state, payload) => {
  state.currentFamilyGroup.data =
    payload && typeof payload === 'object' ? payload : null
  state.currentFamilyGroup.lastUpdate = new Date()
}

export const SET_WALLET_SELECTOR_MODE = (state, payload) => {
  state.walletSelectorMode.data = payload || FILTER_MODE.CLIENTES
  state.walletSelectorMode.lastUpdate = new Date()
}

export const SET_FAMILY_GROUP_WALLET = (state, payload) => {
  state.familyGroupWallet.data =
    payload && typeof payload === 'object' ? payload : null
  state.familyGroupWallet.lastUpdate = new Date()
}
export const SET_FAMILY_GROUP_WALLET_LOADING = (state, payload) => {
  state.familyGroupWallet.loading = Boolean(payload)
}

export const SET_FAMILY_GROUP_MEMBER_BREAKDOWN = (state, payload) => {
  state.familyGroupMemberBreakdown.data =
    payload && typeof payload === 'object' ? payload : null
  state.familyGroupMemberBreakdown.lastUpdate = new Date()
}
export const SET_FAMILY_GROUP_MEMBER_BREAKDOWN_LOADING = (state, payload) => {
  state.familyGroupMemberBreakdown.loading = Boolean(payload)
}

export const SET_FAMILY_GROUP_ASSET_STATISTICS = (state, payload) => {
  state.familyGroupAssetStatistics.data =
    payload && typeof payload === 'object' ? payload : null
  state.familyGroupAssetStatistics.lastUpdate = new Date()
}
export const SET_FAMILY_GROUP_ASSET_STATISTICS_LOADING = (state, payload) => {
  state.familyGroupAssetStatistics.loading = Boolean(payload)
}

export const SET_FAMILY_GROUP_FILTERS = (state, payload) => {
  if (!payload || typeof payload !== 'object') return
  state.familyGroupFilters.data = {
    ...state.familyGroupFilters.data,
    ...payload,
  }
}
export const RESET_FAMILY_GROUP_FILTERS = (state) => {
  state.familyGroupFilters.data = buildDefaultFamilyGroupFilters()
}

export const SET_FAMILY_GROUP_OPTIONS_FIELDS = (state, payload) => {
  state.familyGroupOptionsFields.data = Array.isArray(payload) ? payload : []
  state.familyGroupOptionsFields.lastUpdate = new Date()
}
export const SET_FAMILY_GROUP_OPTIONS_FIELDS_LOADING = (state, payload) => {
  state.familyGroupOptionsFields.loading = Boolean(payload)
}

// RESET: restaura o state inicial (libera dados de cliente/escritório retidos
// entre trocas de perfil/escritório in-SPA). Reatribui cada chave a partir do
// factory — reusa a reatividade existente. [CU-86ajnmt4r]
export const RESET = makeResetMutation(buildInitialState)
